import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "booleanLabel",
})
export class BooleanLabelPipe implements PipeTransform {
  /**
   * Converts a boolean value to a translation key.
   * @param value Boolean value to convert.
   * @return "common.yes", "common.no", or "common.unknown".
   */
  transform(value: boolean | null | undefined): string {
    if (value === true) return "common.yes";
    if (value === false) return "common.no";
    return "common.unknown";
  }
}
